import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { CommitmentCriteriaFormGroup } from '@core/models/contract-commitment-criteria.model';
import {
  CriteriaBaseGroupComponent
} from '@shared/contract/contract-item/contract-commitment/category-group-criteria-component/base/criteria-base-group.component';

@Component({
standalone: false,
  selector: 'app-criteria-group',
  templateUrl: './criteria-group.component.html',
  styleUrls: ['./criteria-group.component.scss'],
})
export class CriteriaGroupComponent extends CriteriaBaseGroupComponent implements OnInit {
  @Input() groupValue? = 0;
  @Input() isPastYearContract: boolean;
  @Output() groupValueChange? = new EventEmitter<number>();
  @Output() groupBaseValueChange? = new EventEmitter<number>();

  ngOnInit() {
    this.initForm();
  }

  onInputChange() {
    const total = Object
      .values(this.groupForm.getRawValue())
      .reduce((sum: number, value: any) => sum + (Number(value) || 0), 0);

    this.groupValue = Number(total);
    this.groupValueChange.emit(this.groupValue);
  }

  onInputBaseChange(criteria, $event, isEditable) {
    if (isEditable && !this.isPastYearContract) {
      criteria.value = Number($event.target.value);
      this.groupBaseValueChange.emit(this.groupValue);
    }
  }


  protected initForm() {
    this.group.commitmentCriterias.forEach(
      (criteria) => {
        if (criteria.template.doubleValue) {
          this.groupForm.addControl(
            `${this.groupPrefix}${criteria.id}`,
            new FormControl(criteria.value2));
        }
    });
    this.onInputChange();
  }
}
